/**
 * @flow
 * @relayHash daa37eb305ccad7badafdc494a38a8cc
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type changeCurrencyMutationVariables = {|
  input: {
    userServiceId: string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    currency?: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    measurementUnit?: ?"CM" | "IN";
    zipCode?: ?string;
    clientMutationId?: ?string;
  };
|};
export type changeCurrencyMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "changeCurrencyMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "dibs-buyer-layout/191.2.14-2018-10-30T15:17:02.390Z/changeCurrencyMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "changeCurrencyMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "changeCurrencyMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
